import React from "react";
import { Link } from "react-router-dom";
import { FileSpreadsheet } from "lucide-react";
import { useAuth } from "../../../context/AuthContext";
import { canAccessFinanceModule } from "../../../utils/roleAccess";
import FinanceAccessDenied from "../../../components/finance/FinanceAccessDenied";
import { AdminPageHero, adminHeroActionClassName } from "../../../modules/admin/ui";
import ListeProformas from "../../Proformas/ListeProformas";

/**
 * Proformas : prestations ponctuelles, chantiers, urgences, devis — pas le cycle d’abonnement récurrent.
 */
export default function FinanceProformasPage(): React.JSX.Element {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return <div className="p-8 text-center text-slate-400">Chargement…</div>;
  }

  if (!user || !canAccessFinanceModule(user.role)) {
    return (
      <div className="p-6">
        <FinanceAccessDenied />
      </div>
    );
  }

  return (
    <div className="flex w-full min-w-0 max-w-none flex-col gap-6">
      <AdminPageHero
        eyebrow="Finance"
        title="Proformas"
        subtitle="À utiliser pour devis, chantiers, urgences ou prestations ponctuelles — pas pour la facturation récurrente d’abonnement (voir contrats / passages validés)."
        actions={
          <>
            <Link to="/admin/finance/factures" className={adminHeroActionClassName(false)}>
              Factures
            </Link>
            <Link
              to="/admin/finance/proformas/nouvelle"
              className={adminHeroActionClassName(false)}
            >
              <FileSpreadsheet className="mr-2 inline h-4 w-4" />
              Nouvelle proforma
            </Link>
          </>
        }
      />
      <ListeProformas />
    </div>
  );
}
